/* eqx-live-stats.js — optional polish for the live ticker. ~1 KB, no network requests.
 *
 * 1. Count-up: every <span class="eqx-stat" data-value="N"> (rendered by snippets/eqx-live-stats.liquid)
 *    rolls from ~yesterday's figure up to N the first time it scrolls into view. The number it
 *    lands on is the real server value — the animation only makes the movement visible.
 *
 * 2. Token swap: anything you can only edit in the theme editor (announcement bar text, Section
 *    Store rich text) can contain {cups} {cups+} {reviews} {reviews+} {customers} {customers+} {rating}
 *    (the sections listed in eqx-live-stats.liquid already replace these server-side; this is the backstop). Those tokens are replaced with
 *    the live values from the JSON blob that `{% render 'eqx-live-stats', emit_data: true %}`
 *    prints once in layout/theme.liquid. Only the containers listed in TOKEN_SCOPES are scanned.
 *
 * Include once in layout/theme.liquid:
 *   {% render 'eqx-live-stats', emit_data: true %}
 *   <script src="{{ 'eqx-live-stats.js' | asset_url }}" defer></script>
 */
(function () {
  var fmt = function (n) { return Math.round(n).toLocaleString('en-CA'); };

  /* ---- 1. count-up --------------------------------------------------------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nodes = document.querySelectorAll('.eqx-stat[data-value]');
  if (nodes.length && 'IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, end = Number(el.dataset.value) || 0;
        // start ~0.25% below the real value (≈ one day of cups at today's pace), or 3 below for reviews
        var start = el.dataset.eqxStat === 'reviews' ? Math.max(0, end - 3) : Math.max(0, Math.floor(end * 0.9975));
        var t0 = performance.now(), dur = 1400;
        (function tick(now) {
          var p = Math.min(1, (now - t0) / dur), ease = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(start + (end - start) * ease);
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
        // rAF pauses in background tabs; guarantee we land on the real value regardless
        setTimeout(function () { el.textContent = fmt(end); }, dur + 250);
      });
    }, { threshold: 0.5 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---- 2. token swap for editor-only text ---------------------------------- */
  var TOKEN_SCOPES = '.announcement-bar, .announcement-bar__message, [data-eqx-tokens]';
  var dataEl = document.getElementById('eqx-live-stats-data');
  if (!dataEl) return;
  var d; try { d = JSON.parse(dataEl.textContent); } catch (err) { return; }
  var fl = function (n, to) { return fmt(Math.floor(n / to) * to) + '+'; };
  var map = { '{cups}': fmt(d.cups), '{cups+}': fl(d.cups, 1000), '{reviews}': fmt(d.reviews), '{reviews+}': fl(d.reviews, 10),
              '{customers}': fmt(d.customers || 0), '{customers+}': fl(d.customers || 0, 100), '{rating}': String(d.rating) };
  var re = /\{(cups\+?|reviews\+?|customers\+?|rating)\}/g;
  var swap = function (root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var t; while ((t = walker.nextNode())) {
      if (re.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(re, function (m) { return map[m]; });
      re.lastIndex = 0;
    }
  };
  document.querySelectorAll(TOKEN_SCOPES).forEach(swap);

  /* ---- 3. late-rendered app content (Klaviyo popups/forms, UpCart drawer) --
     These render after page load, outside the theme's Liquid, so the server-side
     replacer never sees them. Watch for their containers and swap tokens as they
     appear (and re-appear — UpCart re-renders on every cart change). ---------- */
  var LATE = '.klaviyo-form, [class*="klaviyo"], #upCart, [id*="upcart" i], [class*="upcart" i]';
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (mu) {
        for (var i = 0; i < mu.addedNodes.length; i++) {
          var nd = mu.addedNodes[i];
          if (nd.nodeType !== 1) continue;
          if (nd.matches && nd.matches(LATE)) swap(nd);
          else if (nd.querySelector && nd.querySelector(LATE)) nd.querySelectorAll(LATE).forEach(swap);
        }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
